/* eslint-disable @typescript-eslint/naming-convention */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { UnitType, StaticRequirementAccelerationIds } from 'src/api';
import { ConceptInputComponent } from '../../../forms/input/concept-input.component';
import { FlexLayout } from '@ansys-internal/awc-angular/core';
import { AWCListItem } from '@ansys-internal/awc-angular/lists';
import { ConfigurationsService } from 'src/app/shared/services/configurations.service';
import { ArchitectureService } from '../../../../../shared/services/architecture.service';
import { SelectComponent, InputType } from '@ansys-internal/awc-angular/forms';
import { getSelectedValue } from '../../../../../shared/tools/common.utils';
import {FormSelectComponent} from "@ansys-internal/awc-angular/form-select";
import {AWCFormElementSize} from "@ansys-internal/awc-angular/form";
import {FormSwitchComponent} from "@ansys-internal/awc-angular/form-switch";

export type SetPart = [value: string, type: string, id: string, index?: number];

@Component({
    selector: 'app-static-requirements-inputs',
    templateUrl: './static-requirements.component.html',
    styleUrls: ['../inputs.scss'],
    imports: [ConceptInputComponent, FormSelectComponent, FormSwitchComponent]
})
export class StaticRequirementsComponent {
  @Input() part!: StaticRequirementAccelerationIds;
  @Input() update!: boolean;
  @Output() setPart: EventEmitter<SetPart> = new EventEmitter<SetPart>();
  @Output() forceUpdate: EventEmitter<string> = new EventEmitter<string>();
  get selectedLimitCleaned(): string[] {
    return this.selectedLimit.filter((x): x is string => x !== null);
  }
  protected UnitType = UnitType;
  protected InputTypes = InputType;
  protected layout: FlexLayout = FlexLayout.COLUMN;
  protected aerodynamics: AWCListItem[] = [];
  protected masses: AWCListItem[] = [];
  protected wheels: AWCListItem[] = [];
  protected limits: AWCListItem[] = [];
  protected selectedAero: (string | null)[] = [];
  protected selectedMass: (string | null)[] = [];
  protected selectedWheel: (string | null)[] = [];
  protected selectedLimit: (string | null)[] = [];
  protected axleSplitStrategies: AWCListItem[] = [
    {
      id: 'max_efficiency',
      text: 'Max Efficiency',
    },
    {
      id: 'fixed',
      text: 'Fixed',
    },
  ];
  protected axleSplitStrategy: string = this.axleSplitStrategies[0].id;

  constructor(
    private configurationService: ConfigurationsService,
    protected architecture: ArchitectureService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    [this.aerodynamics, this.masses, this.wheels, this.limits] =
      this.configurationService.configurationLists.map((list) => {
        return list.map((item) => {
          return { ...item };
        });
      });

    this.selectedAero = [
      getSelectedValue(this.update, this.part.aero_id, this.aerodynamics),
    ];
    this.part.aero_id = this.selectedAero[0] || '';

    this.selectedMass = [
      getSelectedValue(this.update, this.part.mass_id, this.masses),
    ];
    this.part.mass_id = this.selectedMass[0] || '';

    this.selectedWheel = [
      getSelectedValue(this.update, this.part.wheel_id, this.wheels),
    ];
    this.part.wheel_id = this.selectedWheel[0] || '';

    this.selectedLimit = [
      getSelectedValue(
        this.update,
        this.part.deceleration_limit_id,
        this.limits
      ),
    ];
    this.part.deceleration_limit_id = this.selectedLimit[0];

    if (
      this.part.front_axle_split !== null &&
      this.part.front_axle_split !== undefined
    ) {
      this.axleSplitStrategy = this.axleSplitStrategies[1].id;
    }
  }

  protected changeAxleSplitStrategy($event: string): void {
    this.axleSplitStrategy = $event;
    if (this.axleSplitStrategy === this.axleSplitStrategies[0].id) {
      this.part.front_axle_split = null;
    }
    console.log(this.axleSplitStrategy === this.axleSplitStrategies[0].id, this.part.front_axle_split);
    this.forceUpdate.emit('');
  }

  protected selectionIDSet($event: string | null, type: string): void {
    this.part[type as keyof StaticRequirementAccelerationIds] = $event as never;

    switch (type) {
      case 'deceleration_limit_id':
        this.selectedLimit = $event ? [$event] : [];
        break;
    }

    this.forceUpdate.emit('');
  }

  protected setSteadyState($event: string): void {
    const enabled = $event === 'true';
    this.setPart.emit([`${enabled}`, 'steady_state', this.part.id + 'steady_state']);
    if (!enabled && this.part.steady_state_capability_curve) {
      this.setPart.emit(['false', 'steady_state_capability_curve', this.part.id + 'steady_state_capability_curve']);
    }
  }

  protected readonly AWCFormElementSize = AWCFormElementSize;
}
